import { digitalDistributionTemplateFormToQuery as formToQuery } from './digitalDistributionTemplateFormToQuery';
import { digitalDistributionTemplateQueryToForm as queryToForm } from './digitalDistributionTemplateQueryToForm';

export default { formToQuery, queryToForm };
